if (!customElements.get('shoe-lifts-reviews-carousel')) {
  customElements.define('shoe-lifts-reviews-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      const track = this.querySelector('.shoe-lifts-reviews__track');
      const navigation = this.querySelector('.shoe-lifts-reviews__navigation');
      const previous = this.querySelector('[data-reviews-previous]');
      const next = this.querySelector('[data-reviews-next]');
      if (!track || !navigation || !previous || !next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const update = () => {
        const maximum = track.scrollWidth - track.clientWidth;
        navigation.hidden = maximum <= 1;
        previous.disabled = Math.abs(track.scrollLeft) < 1;
        next.disabled = Math.abs(track.scrollLeft) >= maximum - 1;
      };
      const move = (direction) => {
        const card = track.querySelector('.shoe-lifts-reviews__card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap);
        track.scrollBy({
          left: direction * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(1), options);
      next.addEventListener('click', () => move(-1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      window.addEventListener('resize', update, options);
      update();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}
